import { useQuery, useMutation, useQueryClient } from '../lib/queryClient';
import { getPermissionsList } from '../endpoints/permissions/list_GET.schema';
import { updatePermission } from '../endpoints/permissions/update_POST.schema';

export const usePermissions = (sessionId: string | undefined) => {
  return useQuery({
    queryKey: ['permissions', 'list', sessionId],
    queryFn: () => {
      if (!sessionId) throw new Error('Session ID is required');
      return getPermissionsList({ sessionId });
    },
    enabled: !!sessionId,
  });
};

export const useUpdatePermission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updatePermission,
    onSuccess: async (_data, variables) => {
      // Immediately refresh permissions UI after any add/update/remove action.
      await queryClient.invalidateQueries({
        queryKey: ['permissions', 'list', variables.sessionId],
        exact: true,
      });
      await queryClient.refetchQueries({
        queryKey: ['permissions', 'list', variables.sessionId],
        exact: true,
      });
    },
  });
};
